import {request} from '@/utils/Request';
import type { MyOrder } from './Types';


export const getMyOrder = () => {
    return request.get<MyOrder>('/api/order/myorder');
}